import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react'
import MasterBase from "../components/MasterLayout";
import { getformid, getcontroller, getsubkey, isEmpty } from '../modules/appLibrary';
import { changestatus } from '../modules/formstore';
import { useDispatch, useSelector } from "react-redux";

export const Bases = props => {

    const formid = getformid("Bases", props.location.search);
    const controller = getcontroller("Bases", props.location.search);
    const subkey = getsubkey(props.location.search);
    const dispatch = useDispatch();
    const menuinfo = useSelector(state => state.form.menuinfo);
    const [usecondition, setusecondition] = useState(false);

    const actionurl = {
        "insert": "bases/Insert",
        "update": "bases/Update",
        "delete": "bases/Delete",
    }

    const navmenu = [
        { status: "VIEW", menuid: "excel", icon: "file_download", label: "Excel", title: "現在のシート内容をExcelに出力します" }
    ]

    useEffect(() => {
        if (isEmpty(menuinfo.ctrls)) return;
        setusecondition(menuinfo.ctrls.indexOf("USECOND") !== -1);
    }, [menuinfo]);


    return (
        <div>
            <MasterBase
                formid={formid}
                controller={controller}
                subkey={subkey}
                location={props.location}
                actionurl={actionurl}
                condition={true}
                navmenu={navmenu}
                usecondition={usecondition}
            />
        </div>
    );
};
